import { Flex, Typography, Button, Icons } from 'components';
import { ReactElement, useCallback } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { FormTokenItem } from 'features/mfa/types';
import { createUrl } from 'app/utils';
import { FormInput, FormErrorMessage } from 'features/mfa/styles';

interface TokenDisableProps {
  onClick: (value: string) => void;
}
const Icon = styled(Icons)`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.gray_300};
  margin-right: 8px;
`;

const schema = yup
  .object()
  .shape({
    mfacode: yup.string().required('Você precisa informar o token'),
  })
  .required();

const TokenDisable = ({ onClick }: TokenDisableProps): ReactElement => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      mfacode: '',
    },
  });

  const onSubmit = useCallback((receivedData: FormTokenItem) => {
    if (receivedData) {
      onClick(receivedData.mfacode);
    }
  }, []);

  return (
    <Flex alignSelf="center" flexDirection="row" padding={20} justifyContent="center" maxHeight={600} maxWidth={600} backgroundColor="white">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex justifyContent="center" flexDirection="column">
          <Flex marginBottom={16} justifyContent="center">
            <Typography fontWeight="bold" color="dark_350" textAlign="center">
              Digite o código de recuperação
            </Typography>
          </Flex>
          <Flex maxWidth={500} justifyContent="center">
            <Flex marginBottom={32} justifyContent="center">
              <Typography type="type1" color="dark_350" textAlign="center">
                Quando você configurou a sua autenticação em dois fatores, fornecemos um código de recuperação de 16 dígitos que pode ser usado para
                recuperar sua conta. Digite seu código abaixo para continuar.
              </Typography>
            </Flex>
          </Flex>

          <Flex marginTop={32}>
            <Typography type="type1" fontWeight="bold" color="dark_350">
              Código de recuperação
            </Typography>
            <FormInput
              placeholder="0000 0000 0000 0000"
              {...register('mfacode')}
              style={{ height: 70, fontSize: 20, width: '100%', marginTop: 5 }}
              data-error={errors?.mfacode?.message}
              autoFocus={true}
            />
            {errors?.mfacode?.message ? <FormErrorMessage>{errors?.mfacode?.message}</FormErrorMessage> : null}
          </Flex>

          <Flex marginBottom={32} marginTop={32} flexDirection="row" justifyContent="space-between" alignItems="center">
            <Flex>
              <Icon icon="info" />
            </Flex>

            <Flex maxWidth={500}>
              <Typography type="type1" color="light4">
                A MELVER nunca solicita códigos por telefone ou aplicativos de mensagem. Não compartilhe seu código com outras pessoas.
              </Typography>
            </Flex>
          </Flex>
        </Flex>

        <Flex flexDirection="row" justifyContent="space-between" alignItems="center">
          <Button type="submit" p={24} bg="primary_400" color="white" colorHover="white" size="small">
            Confirmar código
          </Button>
          <Link to={createUrl('mfa/support')}>
            <Typography fontWeight="bold" type="type1" color="primary_400">
              Não tenho acesso ao código de recuperação
            </Typography>
          </Link>
        </Flex>
      </form>
    </Flex>
  );
};

export default TokenDisable;
